import { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";
import { Input } from "@/components/ui/input";

export function PasswordInput({ value, onChange, testid, placeholder }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Lock className="w-4 h-4 absolute top-3.5 start-3 text-slate-400" />
      <Input type={show ? "text" : "password"} required value={value} onChange={onChange} placeholder={placeholder}
        className="ps-9 pe-10 h-12 rounded-xl" data-testid={testid} />
      <button type="button" onClick={() => setShow((s) => !s)} aria-label="toggle password"
        className="absolute top-3 end-3 text-slate-400 hover:text-[#1A5C3A] transition-colors" data-testid={`${testid}-toggle`}>
        {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
      </button>
    </div>
  );
}
